module.exports = __webpack_public_path__ + "img/student-background.b632de87.svg";